import styled from 'styled-components';
import theme from '../../../styles/theme';
import NaviText from '../common/NaviText';
import React, { useState, useCallback } from 'react';
import { Row } from '../../../styles/common';
import { FormControl, InputLabel, TextField, Select, MenuItem } from '@mui/material';
import { useGetCodeList } from '../../../interface/common';
import Button from '../../common/Button';
import { useSetUser } from '../../../interface/users';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }
`;

const UserForm = ({target, onClose}) => {

    const {data : userDeptList} = useGetCodeList('user_dept');
    const {data : userTpList} = useGetCodeList('user_tp');

    const {mutate} = useSetUser();

    const [user, setUser] = useState({...target,detp_cd:target&&target.dept_cd});

    const handleAddClick = useCallback((addItem) => {
        const temp = {
            mode: 'POST',
            user_no: addItem.user_no,
            user_nm: addItem.user_nm,
            pwd: addItem.pwd,
            user_tp: addItem.user_tp,
            detp_cd: addItem.detp_cd,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })
    const handleModClick = useCallback((modItem) => {
        const temp = {
            mode: 'PUT',
            uid: modItem.uid,
            user_no: modItem.user_no,
            user_nm: modItem.user_nm,
            // pwd: modItem.pwd,
            user_tp: modItem.user_tp,
            detp_cd: modItem.detp_cd,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })
    const handleDelClick = useCallback((delItem) => {
        const temp = {
            mode: 'DELETE',
            uid: delItem.uid,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })

    const handlePwdInitClick = (user) => {
        const temp = {
            mode: 'PWD_INIT',
            uid: user.uid,
            user_no: user.user_no,
            user_nm: user.user_nm,
            pwd: user.pwd,
            user_tp: user.user_tp,
            detp_cd: user.detp_cd,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
        )
    }

    const handleValueChange = (id, val) => {
        const temp  = {...user,[id]:val}
        setUser(temp);
    }

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'설정'},{text:'사용자관리'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div style={{flexGrow:1,marginTop:'8px'}}>
                <Row>
                    <TextField 
                        id='user_no' 
                        label='ID' 
                        style={{width:'8rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        InputProps={{
                            readOnly: target ? true : false,
                          }}
                        defaultValue={user && user.user_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='user_nm' 
                        label='사용자명' 
                        style={{width:'8rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={user && user.user_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <FormControl style={{width:'8rem'}} size='small'>
                        <InputLabel id='depTp-label'>부서</InputLabel>
                        <Select label="부서" labelId='depTp-label' size='small' defaultValue={user && user.dept_cd}>
                            {userDeptList && userDeptList.map((item,index)=>{ 
                                return <MenuItem 
                                            key={index} 
                                            value={item.code}
                                            onClick={()=>handleValueChange('detp_cd',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <FormControl style={{width:'8rem'}} size='small'>
                        <InputLabel id='userTp-label'>권한</InputLabel>
                        <Select label="권한" labelId='userTp-label' size='small' defaultValue={user && user.user_tp}>
                            {userTpList && userTpList.map((item,index)=>{ 
                                return <MenuItem 
                                            key={index} 
                                            value={item.code}
                                            onClick={()=>handleValueChange('user_tp',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Row>
                {!target ? 
                    <Row>
                        <Button onClick={()=>handleAddClick(user)} style={{ margin:0 }}>등록</Button>
                    </Row>
                :
                    <React.Fragment>
                        <Row>
                            <Button onClick={()=>handlePwdInitClick(user)} style={{ margin:0 }}>패스워드 초기화</Button>
                        </Row>
                        <Row style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            <Button onClick={()=>handleModClick(user)} style={{ margin:0 }}>수정</Button>
                            <Button onClick={()=>handleDelClick(user)}style={{ margin:0 }}>정지</Button>
                        </Row>
                    </React.Fragment>
                }
            </div>
        </MainWrap>
    )
    
}

export default UserForm;